import API from "@/api";

const state = {
  methods: null,
  subscriptions: [],
  invoices: [],
  nextInvoice: null
  // nextInvoice: {
  //   amount: null,
  //   closed: null,
  //   currency: null,
  //   date: null,
  //   number: null,
  //   paid: null,
  //   status: ""
  // }
};

export const mutations = {
  SET_METHODS(state, payload) {
    state.methods = payload;
  },

  SET_SUBSCRIPTIONS(state, payload) {
    state.subscriptions = payload;
  },

  SET_INVOICES(state, payload) {
    state.invoices = payload;
  },

  SET_NEXT_INVOICE(state, payload) {
    state.nextInvoice = payload;
  }
};

export const actions = {
  async methods({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.getPaymentMethods();
    commit("SET_METHODS", results);

    commit("REQUEST_DECREMENT", null, { root: true });
  },

  async subscriptions({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.getSubscriptions();
    commit("SET_SUBSCRIPTIONS", results.list);

    commit("REQUEST_DECREMENT", null, { root: true });
  },

  async invoices({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.getInvoices();
    commit("SET_INVOICES", results.list);

    commit("REQUEST_DECREMENT", null, { root: true });
  },

  async nextInvoice({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.nextInvoice();
    commit("SET_NEXT_INVOICE", results);

    commit("REQUEST_DECREMENT", null, { root: true });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
